module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.configType) ? _c('div', {
    staticClass: "wrap"
  }, [_c('section', {
    staticClass: "activity-bg"
  }, [_c('img', {
    attrs: {
      "src": _vm.configData.backgroundImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-topbox"
  }, [_c('share', {
    attrs: {
      "title": _vm.configData.subTitle,
      "desc": _vm.configData.shareUrlTitle,
      "imgUrl": _vm.configData.shareUrlImage,
      "link": _vm.link
    }
  }), _vm._v(" "), (_vm.configData.sort != 3) ? _c('img', {
    staticClass: "content-logimg",
    attrs: {
      "src": _vm.configData.logoImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.configData.sort == 3) ? _c('img', {
    staticClass: "content-logimg",
    attrs: {
      "src": _vm.configData.successSubTitle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.configData.sort != 3) ? _c('div', {
    staticClass: "envelope-prompt"
  }, [_c('p', [_vm._v(_vm._s(_vm.isLogin ? "已成功领取" : "领取成功"))]), _vm._v(" "), _c('span', [_vm._v("优惠券已放入" + _vm._s(_vm.upPhoneNum(_vm.phone)) + "的会员账户")])]) : _vm._e(), _vm._v(" "), (_vm.configData.sort == 3) ? _c('div', {
    staticClass: "envelope-prompt"
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("专属百元礼包已放入您的亚朵账户")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-bottbox",
    style: (_vm.configData.marketValue == 1 ? '' : (_vm.configData.envelopeImage ? ('background: url(' + _vm.configData.envelopeImage + ') no-repeat;background-size: 100% 100%;') : ''))
  }, [_c('ul', {
    staticClass: "list-css",
    class: _vm.configData.marketValue == 1 ? 'newbac-css' : 'bac-css',
    style: (_vm.configData.sort == 3 ? 'bottom: 16%;' : ''),
    attrs: {
      "tabindex": "-1"
    }
  }, _vm._l((_vm.couponList), function(item) {
    return _c('li', {
      staticClass: "clearfix content-img",
      style: (_vm.configData.successSubTitle ? ('background: url(' + _vm.configData.successSubTitle + ') no-repeat;background-size: 100% 100%;') : '')
    }, [_c('div', {
      staticClass: "fl price clearfix",
      style: (_vm.configData.successTitle ? ('background: url(' + _vm.configData.successTitle + ') no-repeat;background-size: 100% 100%;') : '')
    }, [_c('p', {}, [_vm._v(_vm._s(item.value) + "元")])]), _vm._v(" "), _c('div', {
      staticClass: "fr content-fr"
    }, [_c('p', {
      staticClass: "count"
    }, [_vm._v(_vm._s(item.disTypeName))]), _vm._v(" "), _c('p', {
      staticClass: "count",
      staticStyle: {
        "color": "#FB3653"
      }
    }, [_vm._v("x" + _vm._s(item.count ? item.count : 1))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bacbottom-img"
  }, [(_vm.configData.marketValue != 1) ? _c('p', {
    staticClass: "content-button",
    style: (_vm.configData.buttonImage ? ('background: url(' + _vm.configData.buttonImage + ') no-repeat;background-size: 100% 100%;') : ''),
    on: {
      "click": function($event) {
        return _vm.goWechat()
      }
    }
  }, [_vm._v("\n                        立即使用")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "dow-title",
    on: {
      "click": _vm.useAction
    }
  })])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "size-color"
  }, [_vm._v("恭喜您\n                        "), _c('br'), _vm._v("成为亚朵金卡会员")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-144d7bb9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/treatmentList.vue
// module id = 154
// module chunks = 2